export default (value) => {
  if (value === null || value === undefined || value === '') {
    return true;
  }

  const re = /^[A-Za-z\s]*$/.test(value);

  return re;
};
